import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import Typography from 'web-library/stories/atom/Typography/Typography';
import Box from 'web-library/stories/atom/Box/Box';

import {typographyTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
      justifyContent: 'space-between !important',
    },
  },
  formTitle: {
    color: theme.color.text.textPrimary,
    marginRight: theme.spacing(3),
     ...typographyTheme(theme, 'h3'),
  },
}));

interface FormHeaderProps {
  title: string;
  containerClassName?: string;
  action?: React.ReactNode;
}

const FormHeader = ({ title = '', containerClassName = '', action }: FormHeaderProps) => {
  const { classes } = useStyles();

  return (
    <Box className={`${classes.container} ${containerClassName}`}>
      <Typography className={classes.formTitle}>{title}</Typography>
      {action || null}
    </Box>
  );
};

export default FormHeader;
